import { Pipe, PipeTransform } from '@angular/core';
import { EPG_list } from './epg.interfaces';

/**
 * Смена дня для списка программы передач.
 */
@Pipe({
    name: 'epgDayChanged',
    pure: false,
})
export class epgDayChangedPipe implements PipeTransform {
    /**
     * Флаг смены дня для списка программы передач
     * @param epg Текущая передача.
     * @param epgNext Следующая передача.
     * @returns Возвращает true, если начало передач имеет разную дневную дату.
     */
    transform(epg:EPG_list, epgNext:EPG_list): boolean {
        const day = (new Date(epg.start*1000)).getDate(),
        dayNext = epgNext ? (new Date(epgNext.start*1000)).getDate() : day;
        if(day === dayNext){
            return false;
        } else {
            return true;
        }
    }
}